import ChargingInfrastructureBarChart from "components/charging/ChargingInfrastructureComponent/ChargingInfrastructureBarChart";
import BusinessContext from "Context/BusinessContext";
import UserContext from "Context/UserProvider";
import React, { useContext, useEffect, useState } from "react";
import { Box, CircularProgress } from '@mui/material';
import { useApiService } from "../../services/ApiService/ApiService";

function ChargingInfrastructurePage(props: any) {
  const {userInfo, setUserInfo} = useContext(UserContext);
  const { fetchWithAuth } = useApiService();
  const [loading, setLoading] = useState(true);
  const [selectWeekData, setSelectWeekData] = useContext(BusinessContext) as any;
  const [infrastructureInsight, setInfrastructureInsight] = useState([]) as any;
  const [maxKwTick, setMaxKwTick] = useState(99) as any;
  const [maxKwTicks, setMaxKwTicks] = useState([]) as any;

  async function fetchChargingInfrastructureInsight() {
    setLoading(true);
    try {
      const response = await fetchWithAuth('/infrastructure/dwelling/chargepoints/list', {
        method: 'POST',
        body: JSON.stringify({
          uuid: userInfo.uuid,
          fleetUuid: userInfo.fleetUuid,
          dayOfWeek: selectWeekData.dateOfWeek,
          dwellingUuid: selectWeekData.dwellingUuid,
          operationalCostModelUuid: selectWeekData.operationalCostModelUuid,
          startDayKey: selectWeekData.startDayKey,
          fleetSnapshotDwellingUuid: selectWeekData.fleetSnapshotDwellingUuid
        })
      });

      const res_obj = await response.json();
      const infrastructureInsightData = res_obj.dwellingVirtualChargePoints.map((e: any) => {
        const list = [] as any;
        setMaxKwTick(e.maxKW);
        e.portA.slots.map((slotA: any, index: any) => list.push({ 
          aChargingRate: slotA ? slotA.chargeRateKW : 0, 
          bChargingRate: e.portB.slots[index] ? e.portB.slots[index].chargeRateKW : 0 
        }));
        return list;
      });

      const maxKwTickData = res_obj.dwellingVirtualChargePoints.map((e: any) => {
        const list = [] as any;
        list.push([0, e.maxKw/2, e.maxKW]);
        return list;
      });

      setInfrastructureInsight(infrastructureInsightData);
      setMaxKwTicks(maxKwTickData);
    } catch (error) {
      console.error('Error fetching charging infrastructure insight:', error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchChargingInfrastructureInsight();
  }, []);

  return (
    <>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <CircularProgress />
        </Box>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 15 }}>
          {infrastructureInsight.map((e: any, index: any) => (
            <ChargingInfrastructureBarChart
              key={index}
              data={e}
              nums={maxKwTicks[index]}
            />
          ))}
        </div>
      )}
    </>
  );
}

export default ChargingInfrastructurePage;
